const rtf = new Intl.RelativeTimeFormat("it", { numeric: "auto" });

// Thresholds in seconds → choose the right unit.
const DIVISIONS = [
  { limit: 60, unit: "second", inSeconds: 1 },
  { limit: 3600, unit: "minute", inSeconds: 60 },
  { limit: 86400, unit: "hour", inSeconds: 3600 },
  { limit: 604800, unit: "day", inSeconds: 86400 },
  { limit: 2592000, unit: "week", inSeconds: 604800 },
  { limit: 31536000, unit: "month", inSeconds: 2592000 },
  { limit: Infinity, unit: "year", inSeconds: 31536000 },
];

/**
 * Human-readable Italian relative time for an absolute instant.
 * @param {number} createdAt epoch ms (Date.now())
 * @param {number} [now] epoch ms, injectable for testing
 * @returns {string} e.g. "Adesso", "1 minuto fa", "2 minuti fa", "1 ora fa"
 */
export function formatRelativeTime(createdAt, now = Date.now()) {
  const elapsedSeconds = Math.round((now - createdAt) / 1000);

  // Clock skew / future timestamps: clamp to "now".
  if (elapsedSeconds < 5) return "Adesso";

  for (const { limit, unit, inSeconds } of DIVISIONS) {
    if (elapsedSeconds < limit) {
      const value = Math.floor(elapsedSeconds / inSeconds);
      // Negative sign => "fa" (in the past).
      return rtf.format(-value, unit);
    }
  }
  return "Adesso";
}